var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 35.155 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.134,16.5,10,20.015h2.268Z",
    transform: "translate(1.032 1.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.053,3H15.908V8.67h4.536v2.268H5.7a3.341,3.341,0,0,0-3.4,3.4V26.814a3.341,3.341,0,0,0,3.4,3.4H6.836V36l7.144-5.784h7.6V22.278H34.053a3.341,3.341,0,0,0,3.4-3.4V6.4A3.341,3.341,0,0,0,34.053,3ZM14.547,25.567l-.567-1.814H10.465l-.68,1.814H7.063l3.742-10.093h2.722l3.742,10.093Zm17.237-8.959v2.268a10.239,10.239,0,0,1-4.423-1.134,12.155,12.155,0,0,1-4.536,1.134l-.113-2.268a8.633,8.633,0,0,0,2.381-.34,7.747,7.747,0,0,1-2.041-3.629h2.381a5.7,5.7,0,0,0,1.814,2.495,5.866,5.866,0,0,0,2.155-4.2H22.6V8.67H26V6.4h2.268V8.67h3.742L32.125,9.8a8.622,8.622,0,0,1-2.495,6.464A7.706,7.706,0,0,0,31.785,16.608Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.095c7fc9a8fe4cad1fa06e0f5afe7686.svg";
export { ForwardRef as ReactComponent };